/** Helpers for multi-select list filters (OR within one filter). */

export function matchesOneOf(selectedValues, actual) {
  if (!selectedValues?.length) return true;
  return selectedValues.includes(actual);
}

export function matchesAnyPredicate(selectedValues, predicate) {
  if (!selectedValues?.length) return true;
  return selectedValues.some(predicate);
}

export function matchesRecruiterKeys(selectedValues, recruiterKey, unassignedKey = '__unassigned__') {
  if (!selectedValues?.length) return true;
  return selectedValues.some(f => {
    if (f === unassignedKey) return !recruiterKey;
    return recruiterKey === f;
  });
}
